import React from "react";
import { CircleAlert } from "lucide-react";
import Tooltip from "components/ui/Tooltip";
import ActiveBadge from "../../../components/ActiveBadge";
import Chip from "../../../components/Chip";
import LifecycleBadge from "../../../components/LifecycleBadge";
import { SUBJECT_TYPE_LABEL } from "../../../features/builder.constants";

function LifecycleCell({ row }) {
  return (
    <div className="flex items-center gap-1.5">
      <LifecycleBadge status={row.status} version={row.version_no} />
      {row.validation_message && (
        <Tooltip content={<span className="whitespace-pre-wrap">{row.validation_message}</span>}>
          <span tabIndex={0} aria-label="Validation message" className="cursor-help">
            <CircleAlert size={14} className={row.status === "ACTIVE" ? "text-warning" : "text-danger"} />
          </span>
        </Tooltip>
      )}
    </div>
  );
}

// Columns of the Source list. `start` is the row number offset of the current page.
export const getSourceColumns = (start) => [
  {
    key: "id",
    label: "S.No",
    width: "70px",
    sortable: false,
    render: (row) => <span className="text-xs text-text_muted">{start + row.__index + 1}</span>,
  },
  {
    key: "label",
    label: "Source",
    sortable: true,
    render: (row) => (
      <div className="flex min-w-0 flex-col">
        <span className="truncate font-medium text-text_primary">{row.label || "—"}</span>
        <span className="truncate font-mono text-[11px] text-text_muted">{row.source_key || "—"}</span>
      </div>
    ),
  },
  {
    key: "root_model",
    label: "Root Model",
    sortable: true,
    render: (row) => <span className="font-mono text-xs text-text_secondary">{row.root_model || "—"}</span>,
  },
  {
    key: "module_key",
    label: "Module",
    sortable: true,
    render: (row) => <span className="text-xs text-text_secondary">{row.module_label || "—"}</span>,
  },
  {
    key: "subject_type",
    label: "Subject",
    sortable: true,
    render: (row) => <span className="whitespace-nowrap text-xs text-text_secondary">{SUBJECT_TYPE_LABEL[row.subject_type] || "—"}</span>,
  },
  {
    key: "status",
    label: "Lifecycle",
    sortable: true,
    render: (row) => <LifecycleCell row={row} />,
  },
  {
    key: "field_count",
    label: "Used",
    sortable: false,
    render: (row) => (
      <div className="flex flex-wrap gap-1">
        <Chip>{row.field_count ?? 0} fields</Chip>
        <Chip>{row.trigger_count ?? 0} triggers</Chip>
        {row.domain_event_count > 0 && <Chip>{row.domain_event_count} events</Chip>}
      </div>
    ),
  },
  {
    key: "is_activated",
    label: "Status",
    sortable: true,
    render: (row) => <ActiveBadge active={row.is_activated} />,
  },
];
